<template>
  <div class="wd-100p ht-50 dp-flex jus-c cr-hui3 bg-hei ft-s14 Roboto">
      <img class="ht-40 mg-r10" :src="require('@/assets/foot.png')"/>
      <!-- <a href="https://silversea-media.com/" target="_blank" class="mg-l-5 cr-hui3">          -->
      © 2022 Frasers Hospitality Pte Ltd. A member of Frasers Property Group.
      <!-- </a> -->
  </div>
</template>

<script>
export default {
  components: { },
  data() {
    return {
    };
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {
    clickref(ref) {
      this.pushr(ref);
    },
  },
  beforeDestroy() {},
};
</script>
